import { Link, Typography } from "@material-ui/core";
import React from "react";
import { useSelector } from "react-redux";
import prettyAddress from "../../../util/prettyAddress";
import './ListingBaseInfo.css';
export default function ListingBaseInfo(props) {
    const dashboard = useSelector((state) => state.dashboard)
    const loading = useSelector((state) => state.dashboard.loading)
    let listingAddress = "";
    if (!loading && dashboard !== null) {
        listingAddress = prettyAddress(dashboard.data);
        listingAddress = listingAddress.split(', ')
    }
    return (
        <div className="listing-base">
                <div className="listing-details">
                    <div className="image-container">
                        <Link href={props.url} target="_blank" rel="noopener" underline="none">
                            <img src={dashboard?.data?.listing_image_url} alt="Listing logo" loading="lazy"></img>
                        </Link>
                    </div>
                    <div className="listing-text">
                        <Typography variant="body1">Your Property</Typography>
                        <div className={props.classes.address}>
                            <Typography variant="h4">{listingAddress[0]},</Typography>
                            <Typography variant="h4">{listingAddress[1]}</Typography>
                        </div>
                        <div>
                            <Typography variant="body2" style={{display: 'inline-block'}}>{`Price Guide `}</Typography>
                            <Typography variant="body1" style={{display: 'inline-block', paddingLeft: "2%"}}>{dashboard.data.pretty_price ? dashboard.data.pretty_price : dashboard.data.price_formatted}</Typography>
                        </div>
                    </div>
                </div>
        </div>
    );
}